import React from 'react';

import { Navigate, useLocation, useParams } from 'react-router-dom';

import { AuthContext } from '../contexts/AuthContext';

const ProtectedRouteWrapper = ({
  componentRender,
  needAuth,
  title,
}: {
  componentRender: (props: any) => React.ReactNode;
  needAuth: boolean;
  title?: string;
}) => {
  const params = useParams();
  const location = useLocation();

  const authContext = React.useContext(AuthContext);

  if (needAuth && !authContext.isAuth && location.pathname !== '/login') {
    const { pathname = '', search = '' } = location;
    const backUrl = pathname + search;
    const to = `/login${backUrl.length ? `?return=${backUrl}` : ''}`;
    return <Navigate to={to} replace />;
  }

  if (title) document.title = title + ' | Походники';

  return <>{componentRender({ match: { params }, location })}</>;
};

export default ProtectedRouteWrapper;
